import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  // Full-viewport variant: fill the task-pane iframe and let the content row flex so the editor
  // grows. Applied only when `fullscreen` is set; every other modal keeps FluentUI's defaults.
  fullscreenSurface: {
    width: "100vw",
    maxWidth: "100vw",
    height: "100vh",
    maxHeight: "100vh",
    margin: 0,
    borderRadius: 0,
    boxSizing: "border-box",
    "& .fui-DialogBody": {
      display: "grid",
      gridTemplateRows: "auto 1fr auto",
      height: "100%",
      maxHeight: "100%",
      minHeight: 0,
    },
    "& .fui-DialogContent": {
      minHeight: 0,
      overflowY: "auto",
    },
  },
  titleActions: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalXXS,
  },
});
